import { createFileRoute } from "@tanstack/react-router"

import { HistoryTab } from "~/features/feature-flags/pages"

export const Route = createFileRoute("/_auth/internal/feature-flags/_overview/history")({
  component: HistoryTab,
})
